import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { display, styled } from '@mui/system';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const SectionWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  paddingTop: '220px',
  paddingBottom: '100px',
  position: 'relative',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    paddingTop: '50px',
  },
}));

const PatternOverlay = styled(Box)({
  position: 'absolute',
  top: '140px',
  left: 0,
  width: '100%',
  height: '100%',
  backgroundImage: 'url(/pattern.svg)',
  backgroundRepeat: 'repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  opacity: 0.1,
  zIndex: 0,
});

const ContentWrapper = styled(Container)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1100px',
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1500px',
  },
}));

const VideoWrapper = styled(Box)({
  position: 'relative',
  display: 'inline-block',
  width: '100%',
  '&::before': {
    zIndex: -1,
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: 'url(/beforevid.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    transform: 'translate(-50px, -50px)',
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-30px',
    left: 0,
    width: '100%',
    height: '30px',
    backgroundImage: 'url(/aftervid.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '10px',
  },
});

const Section1 = () => (
  <SectionWrapper component="section" id="top">
    <PatternOverlay />
    <ContentWrapper maxWidth="xl">
      <Grid container spacing={4} alignItems="center">
        {/* Lewa kolumna – tekst */}
        <Grid item size={{ xs: 12, md: 5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              width: {
                xs: '100%',  // na małych ekranach 100%
                xl: '85%',   // od breakpointu xl wzwyż dajemy 85%
              },
            }}
          >            <Box>
              <Typography
                variant="h1"
                sx={{
                  color: 'white',
                  fontSize: '32px',
                  '@media (min-width:1100px)': { fontSize: '36px' },
                  '@media (min-width:1400px)': { fontSize: '54px' },
                  fontWeight: 'bold',
                  mb: '50px',
                  fontFamily: 'Exo',
                }}
              >
                Od rysunku 2D <br /> do modelu 3D
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: 'white', mb: 2, fontSize: '1rem', maxWidth: '600px' }}
              >
                Rzuty architektoniczne to bogate źródło informacji o budynkach,  jednak trudno je sprawnie wykorzystać.
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'white', mb: 2, fontSize: '1rem', maxWidth: '600px' }}
              >
                Pomiary, obliczenia oraz tworzenie modeli 3D pochłaniają ogrom pracy i kosztów.
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'white', mb: 2, fontSize: '1rem', maxWidth: '600px' }}
              >
                Zmień to z aplikacją Bimetria! Oszczędzaj czas i pieniądze.
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'white', mb: 2, fontSize: '1rem', maxWidth: '600px' }}
              >
                Zobacz filmik wyjaśniający i sprawdź czym jest Bimetria!

              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'white', mb: 4, fontSize: '1rem', maxWidth: '600px' }}
              >
              </Typography>

              <Button
                component="a"
                href="https://app.bimetria.com"
                target="_blank"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: 'turquoise.main',
                  color: 'white',
                  '&:hover': { backgroundColor: 'turquoise.dark' },
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: { xs: '16px', md: '18px' },
                  px: 3,
                  py: { xs: 1.5, md: 1 },
                }}
              >
                Wypróbuj
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Prawa kolumna – YouTube */}
        <Grid item size={{ xs: 12, md: 7 }}>
          <VideoWrapper
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube.com/embed/GMkeNpkTvgE"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sx={{
                width: '90%',
                height: { xs: '200px', sm: '300px', md: '400px' },
                border: 0,
                display: 'block',
              }}
            />
          </VideoWrapper>
        </Grid>
      </Grid>
    </ContentWrapper>
  </SectionWrapper>
);

export default Section1;
